import { Vue, Component, Prop } from 'vue-property-decorator';
import { ResultPageStatusEnum } from '@/components/result-page';
import { NoticeBar } from '@hb/coffee';
import { RouterV2Enum } from '@/router/router-names';

const style = require('./index.module.scss') as Dictionary;


@Component
export default class NewResultPage extends Vue {
  // 提现金额
  @Prop(String) readonly statusText!: string;

  // 结果页状态
  @Prop(String) readonly status!: ResultPageStatusEnum;

  /** 跳转防诈骗中心 */
  private goAntiFraudCenter() {
    this.$router.push({
      path: RouterV2Enum.antiFraudCenter,
    });
  }

  private render() {
    return (
      <div>
        <NoticeBar
          class={style.applyTopNotice}
          scrollable={true}
          text='防诈提醒：目前电信诈骗猖獗，切勿向陌生人转账！警惕"征信洗白、清除网贷额度、注销账户、共享屏幕远程指导"等诈骗套路，保护好您的资金安全。'
          onClick={this.goAntiFraudCenter.bind(this)}
        />
        <div class={style.newResultPage}>
          <div class={style.topContent}>
            <div class={[style.icon, style[`icon_${this.status}`]]} />
            <div class={style.textContent}>
              <div class={style.text}>{ this.statusText }</div>
              <div class={style.msg}>
                {this.$slots.default}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
